import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// TODO: Sobald die produktive Konfigurator-URL feststeht, hier eintragen.
const CONFIGURATOR_URL = "https://kameramasten-tool.emergent.host";

export default function Konfigurator() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="konfigurator-page">
      <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-xl border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group" aria-label="Zur Startseite">
            <img
              src="/brand/xortec-logo.png"
              alt="Xortec"
              className="h-8 md:h-9 w-auto"
            />
          </Link>
          <Link
            to="/"
            data-testid="konfigurator-back-home"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-[#0055A4]"
          >
            <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <iframe
          data-testid="konfigurator-iframe"
          title="Xortec Mastkonfigurator"
          src={CONFIGURATOR_URL}
          className="block w-full border-0"
          style={{ height: "calc(100vh - 4rem)" }}
          allow="clipboard-read; clipboard-write"
        />
      </main>
    </div>
  );
}
